import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import styles from './Settings.module.css';

export default function Settings() {
    const { logout } = useAuth();
    const { isDark, toggleTheme } = useTheme();
    const navigate = useNavigate();

    const handleLogout = async () => {
        if (!window.confirm('Are you sure you want to sign out?')) return;
        await logout();
        navigate('/', { replace: true });
    };

    const handleDeleteAccount = () => {
        // First confirmation
        if (!window.confirm('Are you sure you want to delete your account? Your data will be permanently removed after 30 days.')) {
            return;
        }

        // Second confirmation
        if (!window.confirm('Are you absolutely sure? This cannot be undone. Tap OK one final time to confirm deletion.')) {
            return;
        }

        // TODO: Implement account deletion API call
        alert('AccountSettings deletion functionality coming soon');
    };

    return (
        <main className={styles.page}>
            <div className={styles.inner}>
                {/* ── Screen header ── */}
                <div className={styles.screenHeader}>
                    <button
                        className={styles.backBtn}
                        onClick={() => navigate('/me')}
                        title="Back to profile"
                    >
                        ← Back
                    </button>
                    <h1 className={styles.screenTitle}>Settings</h1>
                    <div style={{ width: '60px' }} /> {/* Spacer for centering */}
                </div>

                {/* ── AccountSettings section ── */}
                <section className={styles.section}>
                    <h2 className={styles.sectionLabel}>Account</h2>
                    <div className={styles.settingsGroup}>
                        <button
                            className={styles.settingsRow}
                            onClick={() => navigate('/settings/account')}
                        >
                            <div>
                                <div className={styles.rowLabel}>Username & Email</div>
                                <div className={styles.rowSub}>Update your login credentials</div>
                            </div>
                            <span className={styles.rowArrow}>›</span>
                        </button>

                        <div className={styles.divider} />

                        <button
                            className={styles.settingsRow}
                            onClick={() => navigate('/settings/password')}
                        >
                            <div>
                                <div className={styles.rowLabel}>Change Password</div>
                                <div className={styles.rowSub}>Add or update your Aluvo password</div>
                            </div>
                            <span className={styles.rowArrow}>›</span>
                        </button>
                    </div>
                </section>

                {/* ── Preferences section ── */}
                <section className={styles.section}>
                    <h2 className={styles.sectionLabel}>Preferences</h2>
                    <div className={styles.settingsGroup}>
                        <button
                            className={styles.settingsRow}
                            onClick={() => navigate('/settings/notifications')}
                        >
                            <div>
                                <div className={styles.rowLabel}>Email & Notifications</div>
                                <div className={styles.rowSub}>Choose which emails and pushes you receive</div>
                            </div>
                            <span className={styles.rowArrow}>›</span>
                        </button>

                        <div className={styles.divider} />

                        <button
                            className={styles.settingsRow}
                            onClick={() => navigate('/settings/blocked-users')}
                        >
                            <div>
                                <div className={styles.rowLabel}>Blocked Users</div>
                                <div className={styles.rowSub}>Manage accounts you've blocked</div>
                            </div>
                            <span className={styles.rowArrow}>›</span>
                        </button>

                        <div className={styles.divider} />

                        <div className={styles.settingsRow}>
                            <div>
                                <div className={styles.rowLabel}>Dark Mode</div>
                                <div className={styles.rowSub}>
                                    {isDark ? 'Dark theme enabled' : 'Light theme enabled'}
                                </div>
                            </div>
                            <label className={styles.switch}>
                                <input
                                    type="checkbox"
                                    checked={isDark}
                                    onChange={toggleTheme}
                                />
                                <span className={styles.slider}></span>
                            </label>
                        </div>
                    </div>
                </section>

                {/* ── Danger zone ── */}
                <section className={styles.section}>
                    <h2 className={styles.sectionLabel}>Danger Zone</h2>
                    <div className={styles.settingsGroup}>
                        <button
                            className={styles.settingsRow}
                            onClick={handleDeleteAccount}
                        >
                            <div>
                                <div className={styles.rowLabel} style={{ color: '#EF4444' }}>
                                    Delete Account
                                </div>
                                <div className={styles.rowSub}>
                                    Permanently removes your account after 30 days
                                </div>
                            </div>
                            <span className={styles.rowArrow} style={{ color: '#EF4444' }}>›</span>
                        </button>
                    </div>
                </section>

                {/* ── Sign out ── */}
                <button className={styles.signOutBtn} onClick={handleLogout}>
                    Sign Out
                </button>

                {/* ── App version ── */}
                <p className={styles.version}>Version 1.0.0</p>
            </div>
        </main>
    );
}